/**
 * AgoraVoiceCall WorldView用RTCクライアント
 */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
if (typeof AgoraRTC === 'object') {
    AgoraRTC.setLogLevel(2);
}
export class AgoraClient {
    setLocalAgoraTrack({ audioTrack , videoTrack  }) {
        if (audioTrack) {
            this._localAgoraTracks.audioTrack = audioTrack;
        }
        if (videoTrack) {
            this._localAgoraTracks.videoTrack = videoTrack;
        }
    }
    getLocalAgoraTrack() {
        return this._localAgoraTracks;
    }
    /**
   * リモートユーザー一覧
   * @return {*}
   */ get remoteUsers() {
        return this._client.remoteUsers;
    }
    get audioTracks() {
        if (!this._localAgoraTracks) {
            return [];
        }
        return [
            this._localAgoraTracks.getMediaStreamTrack()
        ];
    }
    applyUserVolume(user, volume) {
        var _user_audioTrack;
        (_user_audioTrack = user.audioTrack) === null || _user_audioTrack === void 0 ? void 0 : _user_audioTrack.setVolume(volume * 100);
        return;
    }
    updateAllUservolume() {
        this._client.remoteUsers.forEach((agoraUser)=>{
            if (this._remoteVideoLiveStreamUser === agoraUser) {
                return;
            }
            const audioVolume = this._masterMixer.muteVoice ? 0 : Math.floor(this._masterMixer.volumeVoice * 10) / 10;
            this.applyUserVolume(agoraUser, audioVolume);
        });
    }
    updateRemoteVideoLiveStreamVolume() {
        const videoVolume = this._masterMixer.muteVideo ? 0 : Math.floor(this._masterMixer.volumeVideo * 10) / 10;
        this.setRemoteVideoLiveStreamVolume(videoVolume);
    }
    /**
   * heliodorの音量設定を監視
   * intervalを返す
   */ observeVolumeSetting() {
        return setInterval(()=>{
            if (this._importedMixer.volume && this._importedMixer.mute) {
                const changedFlg = this._ctrlPlayerVoiceVolume && this._importedMixer.indexTypeVoice !== null && (this._masterMixer.volumeVoice !== this._importedMixer.volume[this._importedMixer.indexTypeVoice] || this._masterMixer.muteVoice !== this._importedMixer.mute[this._importedMixer.indexTypeVoice]);
                const videoVolumeChangedFlg = this._ctrlRemoteVideoLiveStreamVolume && this._importedMixer.indexTypeVideo !== null && (this._masterMixer.volumeVideo !== this._importedMixer.volume[this._importedMixer.indexTypeVideo] || this._masterMixer.muteVideo !== this._importedMixer.mute[this._importedMixer.indexTypeVideo]);
                this.updateMasterMixer();
                if (changedFlg) {
                    this.updateAllUservolume();
                }
                if (videoVolumeChangedFlg) {
                    this.updateRemoteVideoLiveStreamVolume();
                }
            }
        }, 100);
    }
    updateMasterMixer() {
        this._masterMixer.volumeVoice = this._importedMixer.volume[this._importedMixer.indexTypeVoice];
        this._masterMixer.muteVoice = this._importedMixer.mute[this._importedMixer.indexTypeVoice];
        this._masterMixer.volumeVideo = this._importedMixer.volume[this._importedMixer.indexTypeVideo];
        this._masterMixer.muteVideo = this._importedMixer.mute[this._importedMixer.indexTypeVideo];
    }
    importEngineMasterVolume(mixer, mixerMute, indexTypeVoice, indexTypeVideo = null) {
        this._importedMixer.volume = mixer;
        this._importedMixer.mute = mixerMute;
        this._importedMixer.indexTypeVoice = indexTypeVoice;
        this._importedMixer.indexTypeVideo = indexTypeVideo;
    }
    /**
   *
   * ローカルのマイク入力のON OFF切替
   * @param {*} boolean true マイクON
   *
   */ setMicMuted(boolean) {
        if (!this._localAgoraTracks.audioTrack) {
            return;
        }
        this._localAgoraTracks.audioTrack.setMuted(boolean);
    }
    isMicMuted() {
        if (!this._localAgoraTracks.audioTrack) {
            return null;
        }
        return this._localAgoraTracks.audioTrack.muted;
    }
    setMicEnabled(boolean) {
        if (!this._localAgoraTracks.audioTrack) {
            return;
        }
        this._localAgoraTracks.audioTrack.setEnabled(boolean);
    }
    isMicEnabled() {
        if (!this._localAgoraTracks.audioTrack) {
            return null;
        }
        // 本来は this._localAgoraTracks.audioTrack.enabled で取得できるはずが取れない
        return this._localAgoraTracks.audioTrack._enabled;
    }
    playLiveStreamAudio() {
        if (!this._remoteVideoLiveStreamUser) {
            return;
        }
        if (!this._remoteVideoLiveStreamUser.audioTrack) {
            return;
        }
        this._remoteVideoLiveStreamUser.audioTrack.play();
    }
    stopLiveStreamAudio() {
        if (!this._remoteVideoLiveStreamUser) {
            return;
        }
        if (!this._remoteVideoLiveStreamUser.audioTrack) {
            return;
        }
        this._remoteVideoLiveStreamUser.audioTrack.stop();
    }
    /**
   * constructor
   * @param config:object
   *   mode:string "rtc":全員ホスト or "live":hostとaudienceに分かれるliveStreamingモード. default: "rtc"
   *   remoteVideoElement: VideoElement|null default: null
   */ constructor(config = {
        mode: 'rtc',
        ctrlRemoteVideoLiveStreamVolume: false,
        ctrlPlayerVoiceVolume: false
    }){
        _defineProperty(this, "setMuteAll", (boolean)=>{
            this.muteAllFlg = boolean;
            this._client._remoteUsers.forEach((user)=>{
                if (user.hasAudio && !user.hasVideo) {
                    if (boolean) {
                        user.audioTrack.stop();
                    } else {
                        user.audioTrack.play();
                    }
                }
            });
        });
        _defineProperty(this, "startObserveVolumeSetting", ()=>{
            this.intervalVolumeSettingObserver = this.observeVolumeSetting();
        });
        // AEC: acoustic echo cancellation
        // ANS: automatic noise suppression:
        _defineProperty(this, "initLocalTrack", async ({ cameraId , microphoneId , AEC , AGC , ANS , videoSize  })=>{
            console.log({
                cameraId,
                microphoneId,
                AEC,
                ANS,
                videoSize
            });
            const audioTrackInitConfig = {
                microphoneId: microphoneId
            };
            // acoustic echo cancellation
            if (AEC !== undefined) {
                audioTrackInitConfig.AEC = AEC;
            }
            if (AEC !== undefined) {
                audioTrackInitConfig.AGC = AGC;
            }
            // automatic noise suppression
            if (ANS !== undefined) {
                audioTrackInitConfig.ANS = ANS;
            }
            this._localAgoraTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack(audioTrackInitConfig);
            if (cameraId) {
                const videoWidth = (videoSize === null || videoSize === void 0 ? void 0 : videoSize.width) || 1280;
                const videoHeight = (videoSize === null || videoSize === void 0 ? void 0 : videoSize.height) || 720;
                const encoderConfig = {
                    width: videoWidth,
                    height: videoHeight,
                    frameRate: 30,
                    bitrateMax: 3000
                };
                this._localAgoraTracks.videoTrack = await AgoraRTC.createCameraVideoTrack({
                    cameraId: cameraId,
                    encoderConfig
                });
            }
            return this._localAgoraTracks;
        });
        _defineProperty(this, "changeInputDevices", async ({ cameraId , microphoneId , AEC , AGC , ANS , videoSize  })=>{
            const micMuted = this._localAgoraTracks.audioTrack != null ? this._localAgoraTracks.audioTrack.muted : true;
            if (this.isConnected()) {
                if (microphoneId !== undefined && this._localAgoraTracks.audioTrack) {
                    await this._client.unpublish(this._localAgoraTracks.audioTrack);
                }
                if (cameraId !== undefined && this._localAgoraTracks.videoTrack) {
                    await this._client.unpublish(this._localAgoraTracks.videoTrack);
                }
            }
            await this.initLocalTrack({
                cameraId,
                microphoneId,
                AEC,
                AGC,
                ANS,
                videoSize
            });
            this.setMicMuted(micMuted);
            if (this.isConnected()) {
                await this.publishLocalTracks();
            }
        });
        /**
   * joinしているチャンネル名取得
   * @returns {undefined|string}
   */ _defineProperty(this, "ChannelName", ()=>{
            return this._client.channelName;
        });
        _defineProperty(this, "isConnected", ()=>{
            return this._client.connectionState === 'CONNECTED';
        });
        _defineProperty(this, "getRole", ()=>{
            return this._client.role;
        });
        /**
   * Tokenを外部から渡してHostとしてjoinする
   * @param agoraAppId:string agoraのAppID
   * @param token:string agora用token
   * @param room:string ルームID
   * @param uid:string|number user_id
   * @param mediaStream 入力MediaStream
   * @return {Promise<uid>}
   */ _defineProperty(this, "joinLiveHostByToken", async (agoraAppId, token, roomId, uid, micEnabled = false)=>{
            if (this._mode !== 'live') {
                throw 'joinLiveHost only mode=live';
            }
            if (this._mode === 'live') {
                await this._client.setClientRole('host');
            }
            const agoraUserID = await this._client.join(agoraAppId, roomId, token, uid);
            await this.publishLocalTracks();
            // デフォルトではマイク無効
            this.setMicMuted(!micEnabled);
            return agoraUserID;
        });
        _defineProperty(this, "joinLiveAudienceByToken", async (agoraAppId, token, roomId, uid, latencyLevel = 1)=>{
            if (this._mode !== 'live') {
                throw 'joinLiveAudience only mode=live';
            }
            await this._client.setClientRole('audience', {
                level: latencyLevel
            });
            const agoraUserID = await this._client.join(agoraAppId, roomId, token, uid);
            console.log('join audience success');
            return agoraUserID;
        });
        _defineProperty(this, "joinTalk", async (agoraAppId, token, roomId, uid, micEnabled = false)=>{
            console.log('AGORACLIENT joinTalk', agoraAppId, token, roomId, uid, micEnabled);
            const agoraUserID = await this._client.join(agoraAppId, roomId, token, uid);
            await this.publishLocalTracks();
            // デフォルトではマイク無効
            this.setMicMuted(!micEnabled);
            return agoraUserID;
        });
        _defineProperty(this, "publishLocalTracks", async ()=>{
            const publishMediaTracks = [];
            if (this._localAgoraTracks.videoTrack) {
                publishMediaTracks.push(this._localAgoraTracks.videoTrack);
            }
            if (this._localAgoraTracks.audioTrack) {
                publishMediaTracks.push(this._localAgoraTracks.audioTrack);
            }
            if (publishMediaTracks.length > 0) {
                await this._client.publish(publishMediaTracks);
                console.log('publish success');
                // this.dispatchEvent('publishedLocalStream', {})
                this._client.publish(publishMediaTracks);
            } else {
                console.log('no publish');
            }
        });
        _defineProperty(this, "publishVideoStream", async (mediaStream)=>{
            console.log('agoraClient publishVideoStream', mediaStream);
            const agoraVideoTrack = await AgoraRTC.createCustomVideoTrack({
                mediaStreamTrack: mediaStream.getVideoTracks()[0],
                optimizationMode: 'motion'
            });
            this._client.publish(agoraVideoTrack);
            this._localAgoraTracks.videoTrack = agoraVideoTrack;
        });
        _defineProperty(this, "unpublishVideoStream", async ()=>{
            if (this._localAgoraTracks.videoTrack !== null) {
                await this._client.unpublish(this._localAgoraTracks.videoTrack);
                this._localAgoraTracks.videoTrack.close();
                this._localAgoraTracks.videoTrack = null;
            }
        });
        _defineProperty(this, "unpublish", ()=>{
            agoraClient._client.unpublish();
        });
        _defineProperty(this, "leaveChannel", async ()=>{
            await this._client.leave();
        });
        /**
   * 切断処理
   * @return {Promise<void>}
   */ _defineProperty(this, "close", async ()=>{
            await this.leaveChannel();
            if (this._localAudioTracktrack) {
                this._localAudioTracktrack.stop();
                this._localAudioTracktrack.close();
                this._localAudioTracktrack = undefined;
            }
            this.clearRemoteUser();
        });
        _defineProperty(this, "_subscribe", async (user, mediaType)=>{
            console.log('_subscribe', user, user.hasVideo, mediaType);
            await this._client.subscribe(user, mediaType);
            return;
        });
        _defineProperty(this, "holdRemoteVideoLiveStreamUser", (user)=>{
            console.log('holdRemoteVideoLiveStreamUser', this._remoteVideoLiveStreamUser);
            const isNewStream = this._remoteVideoLiveStreamUser === null;
            this._remoteVideoLiveStreamUser = user;
            if (isNewStream) {
                this.dispatchEvent('startRemoteVideoLiveStream', {
                    user: user,
                    remoteVideoLiveStream: this.getRemoteVideoLiveStream({
                        audioTrack: false
                    })
                });
            } else {
                this.dispatchEvent('updateRemoteVideoLiveStream', {
                    user: user,
                    remoteVideoLiveStream: this.getRemoteVideoLiveStream({
                        audioTrack: false
                    })
                });
            }
        });
        _defineProperty(this, "releaseRemoteVideoLiveStreamUser", ()=>{
            this._remoteVideoLiveStreamUser = null;
        });
        _defineProperty(this, "handleUserPublished", async (user, mediaType)=>{
            console.log('handleUserPublished', mediaType, user);
            const remoteUserParam = this.getRemoteUserParam(user.uid);
            if (!remoteUserParam) {
                this.setRemoteUserParam(user, {
                    volume: 1
                });
                // streamerかspeakerか判定するため、audioとvideoが揃うまでsubscribeを待機
                // 待機しないようにするには、uidでもって判別できるようにする
                setTimeout(()=>{
                    const agoraUser = this.getRemoteUser(user.uid);
                    if (agoraUser.hasVideo) {
                        console.log('as streamer');
                        this.holdRemoteVideoLiveStreamUser(agoraUser);
                        if (this._ctrlRemoteVideoLiveStreamVolume) {
                            this.updateRemoteVideoLiveStreamVolume();
                        }
                    } else {
                        console.log('as speaker');
                        // audio再生開始時にvolume反映
                        if (this._ctrlPlayerVoiceVolume) {
                            this.updateAllUservolume();
                        }
                        this.dispatchEvent('subscribePlayerAudio', {
                            user: agoraUser
                        });
                    }
                }, 1500);
            }
            await this._subscribe(user, mediaType);
            if (this._onStream) {
                this._onStream();
            }
        });
        _defineProperty(this, "handleUserUnpublished", (user, mediaType)=>{
            const id = user.uid;
            const remoteVideoLiveStreamUser = this.getRemoteVideoLiveStreamUser();
            if (remoteVideoLiveStreamUser && id === remoteVideoLiveStreamUser.uid) {
                this.releaseRemoteVideoLiveStreamUser();
                this.dispatchEvent('stopRemoteVideoLiveStream', {
                    user: remoteVideoLiveStreamUser,
                    remoteVideoLiveStream: null
                });
                this.deleteRemoteUser(id);
            }
            if (mediaType === 'audio') {
                this.deleteRemoteUser(id);
            }
        });
        _defineProperty(this, "handleUserJoined", (user)=>{
            if (this._onUserJoined) {
                this._onUserJoined(user);
            }
        });
        _defineProperty(this, "handleUserLeft", (user)=>{
            if (this._onUserLeft) {
                this._onUserLeft(user);
            }
        });
        _defineProperty(this, "onConnected", (handler)=>{
            this._onConnected = handler;
        });
        _defineProperty(this, "onDisconnected", (handler)=>{
            this._onDisconnected = handler;
        });
        _defineProperty(this, "handleConnectionStateChange", (curState, revState, reason)=>{
            console.log('AgoraClient StateChange', curState, revState, reason);
            if (curState === 'CONNECTED') {
                const dispatcherInterval = setInterval(()=>{
                    if (this._client._uid) {
                        clearInterval(dispatcherInterval);
                        this.localUser.uid = this._client._uid;
                        if (this._onConnected) {
                            this._onConnected(this.localUser);
                        }
                    }
                }, 100);
            }
            if (curState === 'DISCONNECTED') {
                this.localUser.uid = null;
                this.releaseRemoteVideoLiveStreamUser();
                if (this._onDisconnected) {
                    this._onDisconnected();
                }
            }
        });
        _defineProperty(this, "setRemoteUserParam", (agoraUser, params)=>{
            this._remoteUsersParam.set(agoraUser.uid, params);
        });
        _defineProperty(this, "getRemoteUserParam", (uid)=>{
            return this._remoteUsersParam.get(uid);
        });
        _defineProperty(this, "getRemoteUser", (uid)=>{
            const user = this._client.remoteUsers.find((user)=>{
                return user.uid == uid;
            });
            return user;
        });
        _defineProperty(this, "deleteRemoteUser", (agoraUid)=>{
            this._remoteUsersParam.delete(agoraUid);
        });
        _defineProperty(this, "clearRemoteUser", ()=>{
            this._remoteUsersParam.clear();
        });
        _defineProperty(this, "onUserJoined", (handler)=>{
            this._onUserJoined = handler;
        });
        _defineProperty(this, "onUserLeft", (handler)=>{
            this._onUserLeft = handler;
        });
        /**
   * リモートユーザーが配信を開始したときに呼ばれるhandlerを設定する
   * @param handler: function({peerId:string|number})
   *   peerId: 配信者のuserID
   *   mediaType:string "audio" or "video"
   *   user: AgoraRTC.IRemoteUser
   *   => boolean: falseを返した場合はsubscribeしない
   */ _defineProperty(this, "onStream", (handler)=>{
            this._onStream = handler;
        });
        /**
   * リモートユーザーのボリュームを変更する
   * @param userID
   * @param volume:number ボリューム(0.0to1.0)
   */ _defineProperty(this, "setUserVolume", (userID, volume)=>{
            const user = this.getRemoteUser(userID);
            const userParam = this._remoteUsersParam.get(userID);
            userParam.volume = volume;
            this._remoteUsersParam.set(userID, {
                volume: userParam.volume
            });
            if (user) {
                this.applyUserVolume(user, volume);
            }
        });
        _defineProperty(this, "setRemoteVideoLiveStreamVolume", (volume)=>{
            var _this__remoteVideoLiveStreamUser;
            if (this._remoteVideoLiveStreamGainNode) {
                this._remoteVideoLiveStreamGainNode.gain.value = volume;
            }
            if ((_this__remoteVideoLiveStreamUser = this._remoteVideoLiveStreamUser) === null || _this__remoteVideoLiveStreamUser === void 0 ? void 0 : _this__remoteVideoLiveStreamUser.audioTrack) {
                this._remoteVideoLiveStreamUser.audioTrack.setVolume(volume * 100);
            }
        });
        _defineProperty(this, "isRemoteVideoLiveStreamReady", ()=>{
            if (this._remoteVideoLiveStreamUser === null) {
                return false;
            }
            if (this._remoteVideoLiveStreamUser.hasAudio && this._remoteVideoLiveStreamUser.hasVideo) {
                return true;
            }
            return false;
        });
        _defineProperty(this, "getRemoteVideoLiveStreamUser", ()=>{
            return this._remoteVideoLiveStreamUser;
        });
        _defineProperty(this, "getRemoteVideoLiveStream", (options)=>{
            if (this._remoteVideoLiveStreamUser === null) {
                return null;
            }
            const audioTrack = this._remoteVideoLiveStreamUser.audioTrack ? this._remoteVideoLiveStreamUser.audioTrack.getMediaStreamTrack() : null;
            const videoTrack = this._remoteVideoLiveStreamUser.videoTrack ? this._remoteVideoLiveStreamUser.videoTrack.getMediaStreamTrack() : null;
            const mediaStream = new MediaStream();
            if (audioTrack && options.audioTrack !== false) {
                if (this._ctrlRemoteVideoLiveStreamVolume) {
                    const ctx = new AudioContext();
                    const source = ctx.createMediaStreamSource(new MediaStream([
                        audioTrack
                    ]));
                    const destination = ctx.createMediaStreamDestination();
                    this._remoteVideoLiveStreamGainNode = ctx.createGain();
                    source.connect(this._remoteVideoLiveStreamGainNode);
                    this._remoteVideoLiveStreamGainNode.connect(destination);
                    mediaStream.addTrack(destination.stream.getAudioTracks()[0]);
                } else {
                    mediaStream.addTrack(audioTrack);
                }
            }
            if (videoTrack && options.videoTrack !== false) {
                mediaStream.addTrack(videoTrack);
            }
            if (mediaStream.getTracks().length > 0) {
                return mediaStream;
            }
            return null;
        });
        /*
  getRemoteVideoLiveStreams = () => {
    return this._remoteVideoLiveStream
  }
  */ _defineProperty(this, "getLocalMediaStream", ()=>{
            const localMediaStream = new MediaStream();
            if (this._localAgoraTracks.audioTrack) {
                localMediaStream.addTrack(this._localAgoraTracks.audioTrack.getMediaStreamTrack());
            }
            if (this._localAgoraTracks.videoTrack) {
                localMediaStream.addTrack(this._localAgoraTracks.videoTrack.getMediaStreamTrack());
            }
            return localMediaStream;
        });
        _defineProperty(this, "switchLocalVideoTrack", async (deviceId)=>{
            const tmpMediaStream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: deviceId
                }
            });
            const newTrack = tmpMediaStream.getVideoTracks()[0];
            // Replaces and stops the current video track
            await this._localAgoraTracks.videoTrack.replaceTrack(newTrack, true);
        });
        _defineProperty(this, "on", (eventName, callback)=>{
            this._eventHandlers[eventName] = callback;
        });
        _defineProperty(this, "dispatchEvent", async (eventName, params)=>{
            if (typeof this._eventHandlers[eventName] === 'function') {
                this._eventHandlers[eventName](params);
            }
        });
        this._mode = config && config['mode'] ? config['mode'] : 'rtc';
        this._ctrlRemoteVideoLiveStreamVolume = config['ctrlRemoteVideoLiveStreamVolume'];
        this._ctrlPlayerVoiceVolume = config['ctrlPlayerVoiceVolume'];
        this._client = AgoraRTC.createClient({
            mode: this._mode,
            codec: 'vp8'
        });
        if (AgoraClient.isUseWebAudioDevice()) {
            AgoraRTC.setParameter('REMOTE_AUDIO_TRACK_USES_WEB_AUDIO', true);
        }
        // 他プレーヤjoin left
        this._client.on('user-joined', this.handleUserJoined);
        this._client.on('user-left', this.handleUserLeft);
        // 他プレーヤストリームpublished unpublished
        this._client.on('user-published', this.handleUserPublished);
        this._client.on('user-unpublished', this.handleUserUnpublished);
        this._client.on('connection-state-change', this.handleConnectionStateChange);
        this._localAgoraTracks = {
            audioTrack: null,
            videoTrack: null
        };
        // 独自のプレーヤ情報
        this._remoteUsersParam = new Map();
        this._importedMixer = {
            volume: null,
            mute: null,
            indexTypeVoice: null,
            indexTypeVideo: null
        };
        this._masterMixer = {
            volume: 1,
            mute: 0
        };
        this._remoteVideoLiveStreamUser = null;
        this._remoteVideoLiveStreamGainNode = null;
        this.intervalVolumeSettingObserver = null;
        this._eventHandlers = {};
        this.muteAllFlg = true;
        this.localUser = {
            uid: null
        };
    }
}
/**
   * remoteAudio の再生に WebAudioを使うDeviceかの判定
   * @return boolean
   */ _defineProperty(AgoraClient, "isUseWebAudioDevice", ()=>{
    const ua = window.navigator.userAgent;
    // iOS Safariの場合 audioTrack.setVolumeが反映されないのでWebAudioを使用する
    if (ua.match(/Version\/([\d\._]+).*Mobile.*Safari.*/)) {
        return true;
    }
    return false;
});
export default AgoraClient;
